import axios from 'axios'
import * as types from '../mutation-types'

import { createTheParametersOfTheUrl } from '../../plugins/helper'

// state
export const state = {
  loading: true,
  searchedResult: [],
  error: null,
}

// mutations
export const mutations = {
  [types.GET_SEEKER_START] (state) {
    state.loading = true
    state.searchedResult = []
    state.error = null
  },

  [types.GET_SEEKER_SUCCESS] (state, { data }) {
    state.loading = false
    state.searchedResult = data
    state.error = null
  },

  [types.GET_SEEKER_ERROR] (state, { error }) {
    state.loading = false
    state.searchedResult = []
    state.error = error
  },
}

export const actions = {
  async getSearchResults ({ commit }, { params, request }) {
    try {
      commit(types.GET_SEEKER_START)
      const href = createTheParametersOfTheUrl(params)
      const { data } = await axios.post(`/api/seeker${href}`, request)

      commit(types.GET_SEEKER_SUCCESS, { data: data.data })
    } catch (e) {
      commit(types.GET_SEEKER_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingSearchedResult: state => state.loading,
  searchedResult: state => state.searchedResult,
  errorSearchedResult: state => state.error,
}
